import {
  billOfMaterialsIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getBomProductionCapacity = {
  name: "getBomProductionCapacity" as const,
  input: z.object({ bomId: billOfMaterialsIdFormat.schema }),
  output: z.object({
    maxProducible: z.number().int(),
    inputs: z.array(
      z.object({
        productId: productIdFormat.schema,
        sku: z.string().nullable(),
        title: z.string(),
        imageUrl: z.string().nullable(),
        quantityPerUnit: z.number().int(),
        available: z.number().int(),
        maxUnits: z.number().int(),
      }),
    ),
  }),
};
